import { render, staticRenderFns } from "./PlatformDetailPage.vue?vue&type=template&id=08ff25ae&scoped=true"
import script from "./PlatformDetailPage.vue?vue&type=script&lang=js"
export * from "./PlatformDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff25ae",
  null
  
)

export default component.exports